


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { formatCurrency } from '@/utils/utils';
import * as moment from 'moment';
import { OrderController } from '@/services/request.service';

const orderDetailTable = [
  {
    key: 'charges',
    dataIndex: 'chargeName',
  },
  {
    key: 'chargeAmount',
    dataIndex: 'money',
    scopedSlots: { customRender: 'chargeAmount' },
  },
  {
    key: 'discount',
    dataIndex: 'benefitMoney',
    scopedSlots: { customRender: 'benefitMoney' },
  },
  {
    key: 'amountReceivable',
    dataIndex: 'receivableMoney',
    scopedSlots: { customRender: 'amountReceivable' },
  },
  {
    key: 'applicableSemester',
    dataIndex: 'applicableSemester',
    scopedSlots: { customRender: 'applicableSemester' },
  },
];

@Component
export default class OrderTable extends Vue {
  @Prop({ default: () => [] }) public data!: Array<any>;
  @Prop({ default: () => {} }) public baseInfo!: any;
  public visible: boolean = false;
  public editRecord: any = {};
  public mode: string = 'edit';
  public moment = moment;
  public formatCurrency = formatCurrency;
  public created() {
  }
  public get columns() {
    const tmp: any = [];
    orderDetailTable.forEach(item => {
      tmp.push({
        ...item,
        title: this.$t(`orderDetailTable.${item.key}`),
      });
    });
    return tmp;
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get totalAmount(): number {
    return this.data.reduce((acc: any, cur: any, idx: number, src: any) => {
      return acc + cur.money;
    }, 0);
  }

  public get totalDiscount(): number {
    return this.data.reduce((acc: any, cur: any, idx: number, src: any) => {
      return acc + cur.benefitMoney;
    }, 0);
  }

  public get totalReceivableAmount(): number {
    return this.data.reduce((acc: any, cur: any, idx: number, src: any) => {
      return acc + cur.receivableMoney;
    }, 0);
  }
}
